
import { Component, Prop } from 'vue-property-decorator'
import StepContent from "@/components/common/StepContent.vue"
import PuzzleImageUpload from "@/components/products/framepuzzle/steps/PuzzleImageUpload.vue"
import DesignPuzzle from "@/components/products/framepuzzle/steps/DesignPuzzle.vue"
import DesignFrame from "@/components/products/framepuzzle/steps/DesignFrame.vue"


@Component({
    name: 'step-content',
    components: {
        PuzzleImageUpload,
        DesignPuzzle,
        DesignFrame
    }
})
export default class StepContentImpl extends StepContent {
    onCancel() {
        this.$emit('cancel')
    }
    onConfirm() {
        this.$emit('confirm')
    }
    onError(message: string) {
        this.$emit('error', message)
    }
    goToMenu() {
        return this.$refs.activeComponent.goToMenu()
    }
}
